import { detectCreditCardType, digitsOnly } from './creditCardValidation'
import type { CreditCardFieldName, CreditCardType } from './creditCardTypes'

export const CREDIT_CARD_MAX_LENGTHS = {
  cardNumber: 19,
  cardNumberAmex: 17,
  expiry: 5,
  cvv: 3,
  cvvAmex: 4,
  zip: 5,
}

export function formatCreditCardNumber(value: string): string {
  const digits = digitsOnly(value)
  if (detectCreditCardType(digits) === 'amex') {
    return [digits.slice(0, 4), digits.slice(4, 10), digits.slice(10, 15)]
      .filter((part) => part.length > 0)
      .join(' ')
  }
  return digits
    .slice(0, 16)
    .match(/.{1,4}/g)
    ?.join(' ') ?? ''
}

export function formatCreditCardExpiry(value: string): string {
  const digits = digitsOnly(value).slice(0, 4)
  if (digits.length < 2) return digits
  if (digits.length === 2) return `${digits}/`
  return `${digits.slice(0, 2)}/${digits.slice(2)}`
}

export function shouldAdvanceCreditCardField(
  field: CreditCardFieldName,
  value: string,
  cardType: CreditCardType | null,
): boolean {
  const digits = digitsOnly(value)
  if (field === 'cardNumber') {
    return digits.length === (cardType === 'amex' ? 15 : 16)
  }
  if (field === 'expiry') return digits.length === 4
  if (field === 'cvv') return digits.length === (cardType === 'amex' ? 4 : 3)
  return false
}
